<template>
  <div
    class="empty-folder d-flex flex-column justify-content-center align-items-center text-center"
  >
    <img src="../assets/no-contributed.png" class="my-3" alt="" />
    <template v-if="directoryUuid">
      <h4>This folder is empty</h4>
      <p class="text-muted">
        Upload scenarios here, or use
        <i class="material-icons align-middle hint-icon">drive_file_move</i>
        <b>Move to folder</b> on any of your scenarios.
      </p>
    </template>
    <template v-else>
      <h4>You haven't uploaded any scenarios yet</h4>
      <p class="text-muted">
        Upload scenarios to keep them here and organise them into folders.
      </p>
    </template>

    <div class="d-flex flex-wrap justify-content-center">
      <router-link :to="uploadRoute" class="btn btn-primary m-1">
        {{ directoryUuid ? "Upload here" : "Upload scenarios" }}
      </router-link>
      <button type="button" class="btn btn-light m-1" @click="onCreateFolder">
        {{ directoryUuid ? "New subfolder" : "New folder" }}
      </button>
    </div>
  </div>
</template>

<script>
import { createFolder } from "@/utils/folder.helper";

export default {
  name: "EmptyFolder",
  computed: {
    directoryUuid() {
      return this.$route.params.directoryUuid || null;
    },
    uploadRoute() {
      return this.directoryUuid
        ? {
            name: "scenarios-upload",
            query: { directoryUuid: this.directoryUuid },
          }
        : { name: "scenarios-upload" };
    },
  },
  methods: {
    onCreateFolder() {
      createFolder(this, this.directoryUuid);
    },
  },
};
</script>

<style scoped>
.empty-folder {
  min-height: 300px;
}

.empty-folder img {
  width: 20%;
  height: auto;
  opacity: 0.5;
}

.hint-icon {
  font-size: 1.1rem;
  color: var(--isim-primary);
}
</style>
